import { P2GBox, P2GCheckBox, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

export const QuoteFilterSectionTitle = ({ title }: { title: string }) => (
  <P2GText variant="body2" fontWeight="bold" colour="textSecondary">
    {title}
  </P2GText>
);

export const QuoteFilterCheckbox = ({
  disable,
  isSelected,
  label,
  onClick
}: {
  disable: boolean;
  isSelected: boolean;
  label: string | ReactNode;
  onClick?: () => void;
}) => (
  <P2GBox
    sx={(t) => ({
      display: 'flex',
      alignItems: 'center',
      gap: t.spacing(1),
      opacity: disable ? 0.3 : 1,
      transition: 'opacity 0.3s'
    })}
    onClick={onClick}
  >
    <P2GCheckBox
      variant="primary"
      error={false}
      labelPlacement="end"
      size="small"
      inputProps={{
        checked: isSelected,
        style: { padding: 0 }
      }}
    />
    <P2GText variant="body2">{label}</P2GText>
  </P2GBox>
);

function QuoteFilterSection({
  title,
  dataTestId,
  children
}: {
  title?: string;
  dataTestId?: string;
  children: React.ReactNode;
}) {
  return (
    <P2GGrid container direction="column" gap={1} dataTestId={dataTestId}>
      {title && (
        <P2GGrid item>
          <QuoteFilterSectionTitle title={title} />
        </P2GGrid>
      )}
      <P2GGrid item>{children}</P2GGrid>
    </P2GGrid>
  );
}

export default QuoteFilterSection;
